import React from 'react'
import {connect} from 'react-redux'
import {FAQSelector, CustomizationSelector, CompanySelector} from '/app/src/model/selectors'
import DateTime from '/app/src/lib/DateTime'

import {Flex, HelpDeskItemPreview} from '/app/src/component'
import style from './style.css'

class Preview extends React.Component {
    render() {
        const {faqId} = this.props
        if (!faqId) {
            return (
                <Flex>
                    Objektet hittades inte. Testa att logga ut och in igen.
                </Flex>
            )
        }
        return (
            <Flex className={style.PreviewWrapper} hAlignContent='center' bg='grey1' w='100%'>
                <Flex className={style.PreviewWrapper} w='90%' marginTop='20px'>
                    <HelpDeskItemPreview {...this.props} />
                </Flex>
            </Flex>
        )
    }
}

function mapStateToProps(state, ownProps) {
    const {faqId} = ownProps;
    if (!faqId){
        return {faqId}
    }
    const color = CustomizationSelector.getColor(state);
    const faq = FAQSelector.getFAQById(state, faqId);
    const question = FAQSelector.getQuestion(faq);
    const answer = FAQSelector.getAnswer(faq);
    const authorName = FAQSelector.getAuthorName(faq);
    let dateModified = FAQSelector.getDateModified(faq);
    dateModified = DateTime.formatDate(dateModified, 'yyyy-mm-dd').replace(/-/g, '/')
    const authorImg = FAQSelector.getAuthorImg(faq);
    const companyDisplayName = CompanySelector.getCompanyDisplayName(state);
    let companyName = CompanySelector.getCompanyName(state);

    if(companyDisplayName){
        companyName = companyDisplayName;
    }

    return { question, answer, authorName, dateModified, authorImg, color, companyName, faqId };
}

export default connect(mapStateToProps)(Preview)



// WEBPACK FOOTER //
// ./src/layout/Dashboard/RightPanel/ClientChatMenu/HelpDesk/RightPanel/Preview/index.js